import React from 'react';

const base =
  'inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-center text-base font-semibold transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-optical-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50';

const variants = {
  primary: 'bg-optical-600 text-white shadow-card hover:bg-optical-700 active:bg-optical-800',
  secondary:
    'border border-slate-200 bg-white text-slate-800 shadow-card hover:border-optical-200 hover:bg-optical-50',
  ghost: 'text-optical-700 hover:bg-optical-50 hover:text-optical-800',
};

function Button({
  variant = 'primary',
  className = '',
  href,
  type = 'button',
  children,
  ...props
}) {
  const combined = `${base} ${variants[variant] ?? variants.primary} ${className}`;

  if (href) {
    return (
      <a href={href} className={combined} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={combined} {...props}>
      {children}
    </button>
  );
}

export default Button;
